<template>
  <div class="mt-2">
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="sub-sub-tab-nav"
        :link-classes="['sub-sub-tab-nav', 'px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
      <!-- :active="isActiveTab(index + 1)" -->
    </b-nav>
    <b-card no-body class="border-top-warning border-3 border-table-radius px-0">
      <router-view :key="routeName" />
    </b-card>
  </div>
</template>


<script>
/* SERVICES */
import Ripple from "vue-ripple-directive";

export default {
  components: {},
  directives: {
    Ripple,
  },
  data() {
    return {
      sidebarEmployee: false,
      filters: false,
      tabs: [],
    };
  },
  computed: {
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.matched[4].name;
    },
    getTabs() {
      return "";
    },
  },
  mounted() {
    this.tabs = this.$route.matched[3].meta.tabs;
  },
  methods: {},
};
</script>


    
    
    